module.exports = __webpack_public_path__ + "img/lc.841ff72e.svg";